import { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Offer = () => {
  const [formData, setFormData] = useState({
    anrede: '',
    vorname: '',
    nachname: '',
    strasse: '',
    plz: '',
    ort: '',
    telefon: '',
    email: '',
    pflegegrad: '',
    nachricht: ''
  });

  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the data to your backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-turquoise-50 to-white">
        <Header />
        <div className="container mx-auto px-4 py-20">
          <div className="max-w-2xl mx-auto text-center">
            <div className="bg-green-500 text-white w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Vielen Dank!</h2>
            <p className="text-lg text-gray-700 mb-8">
              Ihre Anfrage wurde erfolgreich übermittelt. Wir werden uns schnellstmöglich bei Ihnen melden.
            </p>
            <button 
              onClick={() => setSubmitted(false)}
              className="bg-turquoise-400 text-white px-8 py-3 rounded-full font-semibold hover:bg-turquoise-500 transition-colors"
            >
              Weitere Anfrage senden
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-turquoise-50 to-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-turquoise-400 to-turquoise-400 opacity-10"></div>
        <div className="container mx-auto text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Unverbindliches Angebot
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Füllen Sie das folgende Formular aus und wir erstellen Ihnen ein individuelles, kostenloses Angebot
          </p>
        </div>
      </section>

      {/* Form Section */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-3xl">
          <form onSubmit={handleSubmit} className="bg-white rounded-3xl shadow-2xl p-8 md:p-12">
            {/* Anrede */}
            <div className="mb-6">
              <label className="block text-gray-700 font-semibold mb-2">Anrede *</label>
              <div className="flex space-x-4">
                <label className="flex items-center">
                  <input 
                    type="radio" 
                    name="anrede" 
                    value="Herr" 
                    onChange={handleChange}
                    required
                    className="mr-2"
                  />
                  Herr
                </label>
                <label className="flex items-center">
                  <input 
                    type="radio" 
                    name="anrede" 
                    value="Frau" 
                    onChange={handleChange}
                    className="mr-2"
                  />
                  Frau
                </label>
                <label className="flex items-center">
                  <input 
                    type="radio" 
                    name="anrede" 
                    value="Divers" 
                    onChange={handleChange}
                    className="mr-2"
                  />
                  Divers
                </label>
              </div>
            </div>

            {/* Name */}
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Vorname *</label>
                <input 
                  type="text" 
                  name="vorname" 
                  value={formData.vorname}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-turquoise-400 focus:border-transparent"
                  data-testid="vorname-input"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Nachname *</label>
                <input 
                  type="text" 
                  name="nachname" 
                  value={formData.nachname}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-turquoise-400 focus:border-transparent"
                  data-testid="nachname-input"
                />
              </div>
            </div>

            {/* Address */}
            <div className="mb-6">
              <label className="block text-gray-700 font-semibold mb-2">Straße und Hausnummer *</label>
              <input 
                type="text" 
                name="strasse" 
                value={formData.strasse}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-turquoise-400 focus:border-transparent"
                data-testid="strasse-input"
              />
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-gray-700 font-semibold mb-2">PLZ *</label>
                <input 
                  type="text" 
                  name="plz" 
                  value={formData.plz}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-turquoise-400 focus:border-transparent"
                  data-testid="plz-input"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Ort *</label>
                <input 
                  type="text" 
                  name="ort" 
                  value={formData.ort}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-turquoise-400 focus:border-transparent"
                  data-testid="ort-input"
                />
              </div>
            </div>

            {/* Contact */}
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Telefon *</label>
                <input 
                  type="tel" 
                  name="telefon" 
                  value={formData.telefon}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-turquoise-400 focus:border-transparent"
                  data-testid="telefon-input"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-semibold mb-2">E-Mail</label>
                <input 
                  type="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-turquoise-400 focus:border-transparent"
                  data-testid="email-input"
                />
              </div>
            </div>

            {/* Pflegegrad */}
            <div className="mb-6">
              <label className="block text-gray-700 font-semibold mb-2">Pflegegrad</label>
              <select 
                name="pflegegrad" 
                value={formData.pflegegrad}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-turquoise-400 focus:border-transparent"
                data-testid="pflegegrad-select"
              >
                <option value="">Bitte wählen</option>
                <option value="Pflegegrad 1">Pflegegrad 1</option>
                <option value="Pflegegrad 2">Pflegegrad 2</option>
                <option value="Pflegegrad 3">Pflegegrad 3</option>
                <option value="Pflegegrad 4">Pflegegrad 4</option>
                <option value="Pflegegrad 5">Pflegegrad 5</option>
                <option value="Noch nicht beantragt">Noch nicht beantragt</option>
              </select>
            </div>

            {/* Message */}
            <div className="mb-8">
              <label className="block text-gray-700 font-semibold mb-2">Ihre Nachricht</label>
              <textarea 
                name="nachricht" 
                value={formData.nachricht}
                onChange={handleChange}
                rows="5"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-turquoise-400 focus:border-transparent"
                placeholder="Teilen Sie uns mit, wie wir Ihnen helfen können..."
                data-testid="nachricht-textarea"
              ></textarea>
            </div>

            {/* Submit Button */}
            <button 
              type="submit"
              className="w-full bg-gradient-to-r from-turquoise-400 to-turquoise-400 text-white py-4 rounded-full text-lg font-semibold hover:from-turquoise-500 hover:to-turquoise-500 transition-all shadow-lg hover:shadow-xl"
              data-testid="submit-button"
            >
              Angebot anfordern
            </button>

            <p className="text-sm text-gray-600 mt-4 text-center">
              * Pflichtfelder
            </p>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Offer;
